import { memo, useEffect } from "react";
import { useNavigate } from "react-router-dom"; // use useNavigate instead of useNavigate
import Cookies from "universal-cookie";
import { jwtDecode } from "jwt-decode";

const cookies = new Cookies();

const ValidateAuth = ({ children }) => {
  const history = useNavigate(); // use useNavigate instead of useNavigate

  useEffect(() => {
    const token = cookies.get("zk-vg");
    if (token) {
      const isValid = jwtDecode(token);
      const isExp = isValid?.exp;

      if (isExp * 1000 < new Date().getTime()) {
        history("/login"); // use history to navigate
      }
    } else {
      history("/login"); // if no token, navigate to login
    }
  }, [history]);

  return children;
};

export default memo(ValidateAuth);
